import type { EventDefinition } from './navigation';
import type { PnlCardSharedMethod } from './pnl-card-shared';

export type BackerRewardsSharedProperties = {
  userId: string;
  viewerMode: 'own' | 'other';
  method: PnlCardSharedMethod;
};

export const BACKER_REWARDS_SHARED: EventDefinition<BackerRewardsSharedProperties> = {
  name: 'backer_rewards_shared',
};
